<template>
  <div ref="widgetContainer" class="chat-widget-loader-container">
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { globalState } from '@/globalState';

const route = useRoute();
const agentId = ref('');
const apiEndpoint = ref('');
const widgetContainer = ref(null);

onMounted(() => {
  document.documentElement.removeAttribute('dir');
  agentId.value = route.params.agentid;
  apiEndpoint.value = globalState.apiEndpoint;

  if (widgetContainer.value !== null && agentId.value !== undefined && agentId.value !== '' && apiEndpoint.value !== undefined && apiEndpoint.value !== '') {
    while (widgetContainer.value.firstChild !== null) {
      widgetContainer.value.removeChild(widgetContainer.value.firstChild);
    }

    const existingScript = document.querySelector('script[src="/publicAgentSnippet/publicChatAgent.js"]');
    if (existingScript !== null) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.src = '/publicAgentSnippet/publicChatAgent.js';
    script.setAttribute('data-agent-id', agentId.value);
    script.setAttribute('data-api-endpoint', apiEndpoint.value);
    script.setAttribute('data-target-element', 'body');
    script.setAttribute('data-open-on-load', 'true');
    script.defer = true;

    document.body.appendChild(script);

    if (widgetContainer.value !== null) {
        widgetContainer.value.style.display = 'none';
    }

  } else {
    console.error('PublicChatWidgetLoader: Agent ID or API Endpoint is missing, or container not found.');
    if (widgetContainer.value !== null) {
        widgetContainer.value.textContent = 'Error: Could not load chat widget. Agent ID or API configuration is missing.';
    }
  }
});
</script>

<style scoped>
.chat-widget-loader-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: sans-serif;
  text-align: center;
}
</style> 